import { handleApiResponse, apiReadWithAuth } from '../../fetchUtils';
import _ from 'lodash'

export const RESET_COURSE_FORM = 'RESET_COURSE_FORM'
export const BEGIN_COURSE_CREATE = 'BEGIN_COURSE_CREATE'
export const COURSE_CREATE_SUCCESS = 'COURSE_CREATE_SUCCESS'
export const COURSE_CREATE_FAILURE = 'COURSE_CREATE_FAILURE'
export const BEGIN_COURSE_UPDATE = 'BEGIN_COURSE_UPDATE'
export const COURSE_UPDATE_SUCCESS = 'COURSE_UPDATE_SUCCESS'
export const COURSE_UPDATE_FAILURE = 'COURSE_UPDATE_FAILURE'

export function resetCourseForm() {
  return { type: RESET_COURSE_FORM }
}

function beginCourseCreate() {
  return { type: BEGIN_COURSE_CREATE }
}

function courseCreateSuccess(newCourseId) {
  return { type: COURSE_CREATE_SUCCESS, newCourseId }
}

function courseCreateFailure(errorMessage) {
  return { type: COURSE_CREATE_FAILURE, errorMessage }
}

export function submitNewCourse(formData, callback) {
  return dispatch => {
    dispatch(beginCourseCreate())
    return fetch('/courses', {
      credentials: 'include',
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData)
    })
    .then(response => handleApiResponse(response))
    .then(json => {
      if(json.id){
        dispatch(courseCreateSuccess(json.id))
        if(_.isFunction(callback)){ callback() }
      }
      else if(json.unauthorized){ dispatch(courseCreateFailure(json.unauthorized)) }
      else if(json.errors){ dispatch(courseCreateFailure(json.errors.join("\n"))) }
      else { dispatch(courseCreateFailure('Something went wrong!')) }
    })
    .catch(error => dispatch(courseCreateFailure(error.message)))
  }
}

function beginCourseUpdate() {
  return { type: BEGIN_COURSE_UPDATE }
}

function courseUpdateSuccess() {
  return { type: COURSE_UPDATE_SUCCESS }
}

function courseUpdateFailure(errorMessage) {
  return { type: COURSE_UPDATE_FAILURE, errorMessage }
}

export function submitEditCourse(formData) {
  return dispatch => {
    dispatch(beginCourseUpdate())
    return fetch(`/courses/${formData.course.id}`, {
      credentials: 'include',
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData)
    })
    .then(response => handleApiResponse(response))
    .then(json => {
      if(json.id){
        dispatch(courseUpdateSuccess(json.id))
      }
      else if(json.unauthorized){ dispatch(courseUpdateFailure(json.unauthorized)) }
      else { dispatch(courseUpdateFailure(json.errors.join("\n"))) }
    })
    .catch(error => dispatch(courseUpdateFailure(error.message)))
  }
}
